import yup, {
    enumValidator,
    integerPositiveValidator,
    arrayValidator,
    conditionValueValidator,
} from '~/utils/validators.yup';
import { COMPARED_OPTIONS } from '~/config/constants';

export const conditionCheckDetailRule = {
    conditionCheckDetail: yup.object().shape({
        condition1CheckEffects: arrayValidator,
        playerDvCondition1Option: enumValidator(COMPARED_OPTIONS),
        playerDvCondition1Value: integerPositiveValidator.required().max(12),
        condition2CheckEffects: arrayValidator,
        playerDvCondition2Option: enumValidator(COMPARED_OPTIONS),
        playerDvCondition2Value: conditionValueValidator('condition2CheckEffects').min(0).max(12),
        condition3CheckEffects: arrayValidator,
        playerDvCondition3Option: enumValidator(COMPARED_OPTIONS),
        playerDvCondition3Value: conditionValueValidator('condition3CheckEffects').min(0).max(12),
        opponentDvConditionOption: enumValidator(COMPARED_OPTIONS),
        opponentDvConditionValue: integerPositiveValidator.max(12),
    }),
};
